export class Config {
   
    protected readonly BASE_URL = "https://joytogive-api.worldvision.org.ph/api/";
     
    constructor(){
        
    }
}

